import { Text, Title } from '@gjensidige/builders-components';

interface HeaderEquinorFormsProps {
  title: string;
  description: string;
  url: string;
}

const HeaderEquinorForms = ({ title, description, url }: HeaderEquinorFormsProps) => {
  return (
    <>
      <Text className="builders-margin-bottom-30">Claims Form</Text>
      <Title as="h1" size="3" className="builders-margin-bottom-10">
        {title}
      </Title>
      <Text className="builders-margin-bottom-40">
        {description}, please visit following{' '}
        <a href={url} target="_self">
          link
        </a>
        .
      </Text>
      <Text size="small" className="builders-margin-bottom-20">
        Policy holder
      </Text>
      <Text className="builders-margin-bottom-10">Name: </Text>
      <Text className="builders-margin-bottom-30">Equinor ASA.</Text>
      <Text className="builders-margin-bottom-10">Policy number:</Text>
      <Text>89914141</Text>
    </>
  );
};

export default HeaderEquinorForms;
